module.exports = __webpack_public_path__ + "static/img/663414d72b2c47719778ef2f52494e7b_mergeImage.9d95730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/663414d72b2c47719778ef2f52494e7b_mergeImage.png
// module id = oV74
// module chunks = 1